"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = flashInput;

function flashInput(input) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      withInitialDelay = _ref.withInitialDelay;

  if (!input) {
    return Promise.resolve();
  }

  return new Promise(function (resolve) {
    setTimeout(function () {
      input.setAttribute('style', 'color: #27BAA1;');
      setTimeout(function () {
        input.setAttribute('style', 'color: "";');
        resolve();
      }, 150);
    }, withInitialDelay ? 150 : 0);
  });
}